import { FINANCIAL_SORT_TYPES } from "../../config";
import _ from "../../i18n";
import { ChartIcon, TableIcon } from "../common/Icons";

export const tabs = [
  {
    id: "ANALYSIS",
    label: _("analysis"),
  },
  {
    id: "DETAILS",
    label: _("details"),
  },
];

export const SORT_TYPES = Object.keys(FINANCIAL_SORT_TYPES).map((roleType) => {
  return {
    label: _(roleType),
    options: FINANCIAL_SORT_TYPES[roleType].map(({ value, label }) => {
      return { label: _(label), value: value };
    }),
  };
});

export const colors = [
  "#29394d",
  "#6d7f92",
  "#02af8e",
  "#06d9b1",
  "#d87318",
  "#ea8124",
  "#18a0fb",
  "#de4848",
  "#b2bcc6",
  "#e1e4e8",
  "#2e4d66",
  "#3a6e8f",
  "#76c7b7",
  "#f37b59",
  "#5d6a7d",
  "#4caf50",
  "#f44336",
  "#00bcd4",
  "#9c27b0",
  "#ff9800",
];

export const tabs_1 = [
  {
    id: "TAB",
    label: _("tableView"),
    icon: <TableIcon />,
  },
  {
    id: "CHART",
    label: _("graphicView"),
    icon: <ChartIcon />,
  },
];

export const rows = [
  {
    label: "January",
    value: _("January"),
  },
  {
    label: "February",
    value: _("February"),
  },
  {
    label: "March",
    value: _("March"),
  },
  {
    label: "April",
    value: _("April"),
  },
  {
    label: "May",
    value: _("May"),
  },
  {
    label: "June",
    value: _("June"),
  },
  {
    label: "July",
    value: _("July"),
  },
  {
    label: "August",
    value: _("August"),
  },
  {
    label: "September",
    value: _("September"),
  },
  {
    label: "October",
    value: _("October"),
  },
  {
    label: "November",
    value: _("November"),
  },
  {
    label: "December",
    value: _("December"),
  },
];

export const billing_types = [
  {
    label: _("all"),
    value: null,
    color: "",
  },
  {
    label: _("Forfait"),
    value: "Montant fixe annuel",
    color: "#18a0fb",
  },
  {
    label: _("Acompte/Décompte"),
    value: "Acompte",
    color: "#5f5de8",
  },
  {
    label: _("En régie"),
    value: "En régie",
    color: "#01ae8e",
  },
  {
    label: _("Pas de Planning"),
    value: "Pas de planning",
    color: "#9c27b0",
  },
];

export const getSearchValueStyle = () => ({
  width: 44,
  height: 19,
  padding: 5,
  fontSize: 13,
  marginRight: 5,
  borderRadius: 13,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "rgb(255, 255, 255)",
  background: "rgb(109, 127, 146)",
});

export const monthToIndex = {
  January: 0,
  February: 1,
  March: 2,
  April: 3,
  May: 4,
  June: 5,
  July: 6,
  August: 7,
  September: 8,
  October: 9,
  November: 10,
  December: 11,
};

export const monthNames = [
  "january",
  "february",
  "march",
  "april",
  "may",
  "june",
  "july",
  "august",
  "september",
  "october",
  "november",
  "december",
];

export const suspecionTabs = [
  { label: _("all"), value: false },
  { label: _("suspect"), value: true },
];
